export default __webpack_public_path__ + "static/media/TR.20c4f6c6.svg";